import { Button, Link } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import JoinForm from "./assets/forms/JoiningForm.pdf";
import DirectDebitForm from "./assets/forms/DirectDebit.pdf";

export function JoinNow() {
  return (
    <div className="section-shell">
      <div className="section-grid">
        <section className="section-column" id="join" tabIndex={-1} aria-labelledby="join-title">
          <span className="eyebrow">Make your next move</span>
          <h2 className="section-title" id="join-title">JOIN NOW</h2>
          <p className="body-copy">
            The following join form will need to be filled out when joining NRG.
            The additional direct debit form is only necessary for direct debit
            memberships.
          </p>
          <div className="form-actions">
            <Button variant="contained" href={JoinForm} target="_blank" rel="noopener noreferrer" endIcon={<CreditCardIcon />}>
              Join form
            </Button>
            <Button variant="outlined" href={DirectDebitForm} target="_blank" rel="noopener noreferrer" endIcon={<DynamicFormIcon />}>
              Direct debit form
            </Button>
          </div>
        </section>
        <section className="section-column" id="contact" tabIndex={-1} aria-labelledby="contact-title">
          <span className="eyebrow">Find us in Lota</span>
          <h2 className="section-title" id="contact-title">CONTACT &amp; LOCATION</h2>
          <p className="body-copy contact-copy">
            Contact Lee on <Link href="tel:0413544237">0413 544 237</Link> or via email at{" "}
            <Link href="mailto:lee@positivenrgfitness.com">lee@positivenrgfitness.com</Link>{" "}
            with any enquiries.
          </p>
          <address className="contact-address">41 Railway Terrace, Lota, 4179, QLD, Australia</address>
          <iframe
            className="location-map"
            title="Positive NRG location"
            loading="lazy"
            src="https://maps.google.com/maps?q=44%20RAILWAY%20TERRACE,%20LOTA&t=&z=13&ie=UTF8&iwloc=&output=embed"
          />
        </section>
      </div>
    </div>
  );
}
